export default {
  data() {
    return {
      // experimental: Light/Dark mode switch
      theme: {
        hideSwitch: false,
        selected: 'dark',
        options: [
          { text: 'Light', icon: 'day', value: 'light', disabled: false },
          { text: 'Dark', icon: 'night', value: 'dark', disabled: false }
        ]
      }
    };
  },
  
  methods: {
    themeChanged(ev) {
      this.setTheme(ev);
      // TODO: DX umschalten
      // DevExpress.viz.currentTheme(DevExpress.devices.current(), 'dark');
    },

    getTheme() {
      return localStorage.getItem("user-theme");
    },

    setTheme(theme) {
      localStorage.setItem("user-theme", theme);
      this.theme.selected = theme;
      document.documentElement.className = `${theme}-theme`;
    },

    getMediaPreference() {
      const hasDarkPreference = window.matchMedia(
        "(prefers-color-scheme: dark)"
      ).matches;
      return "dark" ;
      return hasDarkPreference ? "dark" : "light";
    }
  },

  computed: {
    getBackground() {
      return this.theme.selected === 'light' ? 'light' : 'dark';
    },

    getForeground() {
      return this.theme.selected === 'light' ? 'light' : 'dark';
    }
  }
};
